import { useEffect } from "react";
import { useCourseDetailStore } from "@/stores/courseDetailStore";

/**
 * Puts the course title in the header on pages that do not load the whole
 * course (the dashboard does the same).
 */
const useCourseTitleInHeader = (courseTitle: string | undefined) => {
  const showCourseTitleInHeader = () => {
    if (courseTitle) useCourseDetailStore.setState({ courseTitle });
  };

  useEffect(showCourseTitleInHeader, [courseTitle]);
};

export { useCourseTitleInHeader };
